export default "__VITE_ASSET__BAQhGFFg__"